module.exports = __webpack_public_path__ + "tz.91ebff147b9da51102e0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/tz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/tz.svg
// module chunks = styles